import React from 'react';
import styles from './style.module.scss';
import ReviewHeader from '../common/ReviewHeader';
import { dateFormatter } from '../../../../../../../../../components/helper/helper';
import useSalesFormStore from '../../../../../../../../stores/sales-form';


const PersonalInformation = ({ formik, onEdit, isOpen, onToggle }) => {
  const { values } = formik;

  const countryList = useSalesFormStore((state) => state.countryList);

  const formatPeriod = (years, months) => {
    const yearText = years > 0 ? `${years} year${years > 1 ? 's' : ''}` : '0 years';
    const monthText = months > 0 ? `${months} month${months > 1 ? 's' : ''}` : '0 months';
    return [yearText, monthText].filter(Boolean).join(' ');
  };

  const SectionHeader = ({ title }) => (
    <div className={styles.sectionHeader} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span className={styles.sectionTitle}>{title}</span>
      <div className={styles.sectionLine} />
    </div>
  );

  const getCountryName = (countryCode) => {
    const country = countryList.find(c => c.value === countryCode);
    return country ? country.label : countryCode;
  };

  return (
    <div className={styles.personal_information}>
      <ReviewHeader
        title="Personal Information"
        isOpen={isOpen}
        onToggle={onToggle}
        onEdit={onEdit}
      />

      {isOpen && (
        <div className={styles.content}>
          <div className={styles.detailsGrid}>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>First Name</div>
              <div className={styles.detailValue}>{values.personal_first_name || '-'}</div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>Last Name</div>
              <div className={styles.detailValue}>{values.personal_last_name || '-'}</div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>Personal Phone</div>
              <div className={styles.detailValue}>{values.business_phone || '-'}</div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>Personal Email</div>
              <div className={styles.detailValue}>{values.business_email || '-'}</div>
            </div>
          </div>

          <div className={styles.section}>
            <SectionHeader title="ADDRESS" />            
            <div className={styles.detailsGrid}>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Street Address</div>
                <div className={styles.detailValue}>{values.dba_address || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>City</div>
                <div className={styles.detailValue}>{values.dba_city || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>State</div>
                <div className={styles.detailValue}>{values.dba_state || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Zip</div>
                <div className={styles.detailValue}>{values.dba_zip || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Period of Residence</div>
                <div className={styles.detailValue}>
                  {formatPeriod(values.field_residenceyears, values.field_residencemonths) || '-'}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <SectionHeader title="IDENTITY DOCUMENT" />
            <div className={styles.detailsGrid}>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>ID Type</div>
                <div className={styles.detailValue}>
                  {values.field_documenttype ? values.field_documenttype.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : '-'}
                </div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>ID Number</div>
                <div className={styles.detailValue}>{values.field_documentnumber || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>{values.field_documenttype === "PASSPORT" ? "Passport Country" : "Document State"}</div>
                <div className={styles.detailValue}>{values.field_documenttype === "PASSPORT" ? getCountryName(values.document_country) : values.field_driverstate || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Social Security Number</div>
                <div className={styles.detailValue}>{values.field_socialsecurity || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Date of Birth</div>
                <div className={styles.detailValue}>{values.field_birthdate ? dateFormatter(values.field_birthdate) : '-'}</div>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <SectionHeader title="OWNERSHIP" />
            <div className={styles.detailsGrid}>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Ownership Percentage</div>
                <div className={styles.detailValue}>{values.field_ownershippercentage ? `${values.field_ownershippercentage}%` : '-'}</div>
              </div>
            </div>
          </div>          

          {values.additional_owners && values.additional_owners.length > 0 && values.additional_owners.map((owner, index) => (
            <div key={index} className={styles.section}>
              <SectionHeader title={`ADDITIONAL OWNER #${index + 2}`} />
              <div className={styles.detailsGrid}>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>First Name</div>
                  <div className={styles.detailValue}>{owner.signer_first_name || '-'}</div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>Last Name</div>
                  <div className={styles.detailValue}>{owner.signer_last_name || '-'}</div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>Personal Phone</div>
                  <div className={styles.detailValue}>{owner.signer_phone || '-'}</div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>Personal Email</div>
                  <div className={styles.detailValue}>{owner.signer_email || '-'}</div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>City</div>
                  <div className={styles.detailValue}>{owner.signer_city || '-'}</div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>State</div>
                  <div className={styles.detailValue}>{owner.signer_state || '-'}</div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>Zip</div>
                  <div className={styles.detailValue}>{owner.signer_zip || '-'}</div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>Period of Residence</div>
                  <div className={styles.detailValue}>
                    {formatPeriod(owner.signer_residence_years, owner.signer_residence_months) || '-'}
                  </div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>ID Type</div>
                  <div className={styles.detailValue}>
                    {owner.signer_document_type ? owner.signer_document_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : '-'}
                  </div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>ID Number</div>
                  <div className={styles.detailValue}>{owner.signer_drivers_license_number || '-'}</div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>Social Security Number</div>
                  <div className={styles.detailValue}>{owner.signer_social_security || '-'}</div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>Date of Birth</div>
                  <div className={styles.detailValue}>{owner.signer_date_of_birth || '-'}</div>
                </div>
                <div className={styles.detailItem}>
                  <div className={styles.detailLabel}>Ownership Percentage</div>
                  <div className={styles.detailValue}>{owner.signer_ownership_percentage ? `${owner.signer_ownership_percentage}%` : '-'}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PersonalInformation; 